export const CSSReference = [
    {
        name: "accentColor",
        description: "Specifies an accent color for user-interface controls"
    },
    {
        name: "alignContent",
        description: "Specifies the alignment between the lines inside a flexible container when the items do not use all available space"
    },
    {
        name: "alignItems",
        description: "Specifies the alignment for items inside a flexible container"
    },
    {
        name: "alignSelf",
        description: "Specifies the alignment for selected items inside a flexible container"
    },
    {
        name: "alignmentBaseline",
        description: "Specifies how an inline-level element's baseline is aligned within a text"
    },
    {
        name: "all",
        description: "Resets all properties (except unicode-bidi and direction)"
    },
    {
        name: "animation",
        description: "A shorthand property for all the animation-* properties"
    },
    {
        name: "animationComposition",
        description: "Defines how animations are composited together"
    },
    {
        name: "animationDelay",
        description: "Specifies a delay for the start of an animation"
    },
    {
        name: "animationDirection",
        description: "Specifies whether an animation should be played forwards, backwards or in alternate cycles"
    },
    {
        name: "animationDuration",
        description: "Specifies how long an animation should take to complete one cycle"
    },
    {
        name: "animationFillMode",
        description: "Specifies a style for the element when the animation is not playing (before it starts, after it ends, or both)"
    },
    {
        name: "animationIterationCount",
        description: "Specifies the number of times an animation should be played"
    },
    {
        name: "animationName",
        description: "Specifies a name for the @keyframes animation"
    },
    {
        name: "animationPlayState",
        description: "Specifies whether the animation is running or paused"
    },
    {
        name: "animationTimingFunction",
        description: "Specifies the speed curve of an animation"
    },
    {
        name: "appearance",
        description: "Allows for styling of form elements to match the native look and feel"
    },
    {
        name: "aspectRatio",
        description: "Specifies preferred aspect ratio of an element"
    },
    {
        name: "backdropFilter",
        description: "Defines a graphical effect to the area behind an element"
    },
    {
        name: "backfaceVisibility",
        description: "Defines whether or not the back face of an element should be visible when facing the user"
    },
    {
        name: "background",
        description: "A shorthand property for all the background-* properties"
    },
    {
        name: "backgroundAttachment",
        description: "Sets whether a background image scrolls with the rest of the page, or is fixed"
    },
    {
        name: "backgroundBlendMode",
        description: "Specifies the blending mode of each background layer (color/image)"
    },
    {
        name: "backgroundClip",
        description: "Defines how far the background (color or image) should extend within an element"
    },
    {
        name: "backgroundColor",
        description: "Specifies the background color of an element"
    },
    {
        name: "backgroundImage",
        description: "Specifies one or more background images for an element"
    },
    {
        name: "backgroundOrigin",
        description: "Specifies the origin position of a background image"
    },
    {
        name: "backgroundPosition",
        description: "Specifies the position of a background image"
    },
    {
        name: "backgroundPositionX",
        description: "Specifies the position of a background image on x-axis"
    },
    {
        name: "backgroundPositionY",
        description: "Specifies the position of a background image on y-axis"
    },
    {
        name: "backgroundRepeat",
        description: "Sets if/how a background image will be repeated"
    },
    {
        name: "backgroundSize",
        description: "Specifies the size of the background images"
    },
    {
        name: "baselineShift",
        description: "Adjusts the position of an element's baseline"
    },
    {
        name: "blockSize",
        description: "Specifies the size of an element in block direction"
    },
    {
        name: "border",
        description: "A shorthand property for border-width, border-style and border-color"
    },
    {
        name: "borderBlock",
        description: "A shorthand property for border-block-width, border-block-style and border-block-color"
    },
    {
        name: "borderBlockColor",
        description: "Sets the color of the borders at start and end in the block direction"
    },
    {
        name: "borderBlockEnd",
        description: "A shorthand property for border-block-end-width, border-block-end-style and border-block-end-color"
    },
    {
        name: "borderBlockEndColor",
        description: "Sets the color of the border at the end in the block direction"
    },
    {
        name: "borderBlockEndStyle",
        description: "Sets the style of the border at the end in the block direction"
    },
    {
        name: "borderBlockEndWidth",
        description: "Sets the width of the border at the end in the block direction"
    },
    {
        name: "borderBlockStart",
        description: "A shorthand property for border-block-start-width, border-block-start-style and border-block-start-color"
    },
    {
        name: "borderBlockStartColor",
        description: "Sets the color of the border at the start in the block direction"
    },
    {
        name: "borderBlockStartStyle",
        description: "Sets the style of the border at the start in the block direction"
    },
    {
        name: "borderBlockStartWidth",
        description: "Sets the width of the border at the start in the block direction"
    },
    {
        name: "borderBlockStyle",
        description: "Sets the style of the borders at start and end in the block direction"
    },
    {
        name: "borderBlockWidth",
        description: "Sets the width of the borders at start and end in the block direction"
    },
    {
        name: "borderBottom",
        description: "A shorthand property for border-bottom-width, border-bottom-style and border-bottom-color"
    },
    {
        name: "borderBottomColor",
        description: "Sets the color of the bottom border"
    },
    {
        name: "borderBottomLeftRadius",
        description: "Defines the radius of the border of the bottom-left corner"
    },
    {
        name: "borderBottomRightRadius",
        description: "Defines the radius of the border of the bottom-right corner"
    },
    {
        name: "borderBottomStyle",
        description: "Sets the style of the bottom border"
    },
    {
        name: "borderBottomWidth",
        description: "Sets the width of the bottom border"
    },
    {
        name: "borderCollapse",
        description: "Sets whether table borders should collapse into a single border or be separated"
    },
    {
        name: "borderColor",
        description: "Sets the color of the four borders"
    },
    {
        name: "borderEndEndRadius",
        description: "Sets the radius of the corner between the block-end and the inline-end sides of the element"
    },
    {
        name: "borderEndStartRadius",
        description: "Sets the radius of the corner between the block-end and the inline-start sides of the element"
    },
    {
        name: "borderImage",
        description: "A shorthand property for all the border-image-* properties"
    },
    {
        name: "borderImageOutset",
        description: "Specifies the amount by which the border image area extends beyond the border box"
    },
    {
        name: "borderImageRepeat",
        description: "Specifies whether the border image should be repeated, rounded or stretched"
    },
    {
        name: "borderImageSlice",
        description: "Specifies how to slice the border image"
    },
    {
        name: "borderImageSource",
        description: "Specifies the path to the image to be used as a border"
    },
    {
        name: "borderImageWidth",
        description: "Specifies the width of the border image"
    },
    {
        name: "borderInline",
        description: "A shorthand property for border-inline-width, border-inline-style and border-inline-color"
    },
    {
        name: "borderInlineColor",
        description: "Sets the color of the borders at start and end in the inline direction"
    },
    {
        name: "borderInlineEnd",
        description: "A shorthand property for border-inline-end-width, border-inline-end-style and border-inline-end-color"
    },
    {
        name: "borderInlineEndColor",
        description: "Sets the color of the border at the end in the inline direction"
    },
    {
        name: "borderInlineEndStyle",
        description: "Sets the style of the border at the end in the inline direction"
    },
    {
        name: "borderInlineEndWidth",
        description: "Sets the width of the border at the end in the inline direction"
    },
    {
        name: "borderInlineStart",
        description: "A shorthand property for border-inline-start-width, border-inline-start-style and border-inline-start-color"
    },
    {
        name: "borderInlineStartColor",
        description: "Sets the color of the border at the start in the inline direction"
    },
    {
        name: "borderInlineStartStyle",
        description: "Sets the style of the border at the start in the inline direction"
    },
    {
        name: "borderInlineStartWidth",
        description: "Sets the width of the border at the start in the inline direction"
    },
    {
        name: "borderInlineStyle",
        description: "Sets the style of the borders at start and end in the inline direction"
    },
    {
        name: "borderInlineWidth",
        description: "Sets the width of the borders at start and end in the inline direction"
    },
    {
        name: "borderLeft",
        description: "A shorthand property for all the border-left-* properties"
    },
    {
        name: "borderLeftColor",
        description: "Sets the color of the left border"
    },
    {
        name: "borderLeftStyle",
        description: "Sets the style of the left border"
    },
    {
        name: "borderLeftWidth",
        description: "Sets the width of the left border"
    },
    {
        name: "borderRadius",
        description: "A shorthand property for the four border-*-radius properties"
    },
    {
        name: "borderRight",
        description: "A shorthand property for all the border-right-* properties"
    },
    {
        name: "borderRightColor",
        description: "Sets the color of the right border"
    },
    {
        name: "borderRightStyle",
        description: "Sets the style of the right border"
    },
    {
        name: "borderRightWidth",
        description: "Sets the width of the right border"
    },
    {
        name: "borderSpacing",
        description: "Sets the distance between the borders of adjacent cells"
    },
    {
        name: "borderStartEndRadius",
        description: "Sets the radius of the corner between the block-start and the inline-end sides of the element"
    },
    {
        name: "borderStartStartRadius",
        description: "Sets the radius of the corner between the block-start and the inline-start sides of the element"
    },
    {
        name: "borderStyle",
        description: "Sets the style of the four borders"
    },
    {
        name: "borderTop",
        description: "A shorthand property for border-top-width, border-top-style and border-top-color"
    },
    {
        name: "borderTopColor",
        description: "Sets the color of the top border"
    },
    {
        name: "borderTopLeftRadius",
        description: "Defines the radius of the border of the top-left corner"
    },
    {
        name: "borderTopRightRadius",
        description: "Defines the radius of the border of the top-right corner"
    },
    {
        name: "borderTopStyle",
        description: "Sets the style of the top border"
    },
    {
        name: "borderTopWidth",
        description: "Sets the width of the top border"
    },
    {
        name: "borderWidth",
        description: "Sets the width of the four borders"
    },
    {
        name: "bottom",
        description: "Sets the elements position, from the bottom of its parent element"
    },
    {
        name: "boxShadow",
        description: "Attaches one or more shadows to an element"
    },
    {
        name: "boxSizing",
        description: "Defines how the width and height of an element are calculated: should they include padding and borders, or not"
    },
    {
        name: "breakAfter",
        description: "Specifies whether or not a page-, column-, or region-break should occur after the specified element"
    },
    {
        name: "breakBefore",
        description: "Specifies whether or not a page-, column-, or region-break should occur before the specified element"
    },
    {
        name: "breakInside",
        description: "Specifies whether or not a page-, column-, or region-break should occur inside the specified element"
    },
    {
        name: "captionSide",
        description: "Specifies the placement of a table caption"
    },
    {
        name: "caretColor",
        description: "Specifies the color of the cursor (caret) in inputs, textareas, or any element that is editable"
    },
    {
        name: "clear",
        description: "Specifies what should happen with the element that is next to a floating element"
    },
    {
        name: "clip",
        description: "Clips an absolutely positioned element"
    },
    {
        name: "clipPath",
        description: "Clips an element to a basic shape or to an SVG source"
    },
    {
        name: "clipRule",
        description: "Defines the clipping path rule for an element"
    },
    {
        name: "color",
        description: "Sets the color of text"
    },
    {
        name: "colorInterpolation",
        description: "Specifies the color space for gradient interpolations, image color, and alpha compositing"
    },
    {
        name: "colorInterpolationFilters",
        description: "Defines the color space used by filters operations"
    },
    {
        name: "colorScheme",
        description: "Specifies the preferred color scheme for web content"
    },
    {
        name: "columnCount",
        description: "Specifies the number of columns an element should be divided into"
    },
    {
        name: "columnFill",
        description: "Specifies how to fill columns, balanced or not"
    },
    {
        name: "columnGap",
        description: "Specifies the gap between the columns"
    },
    {
        name: "columnRule",
        description: "A shorthand property for all the column-rule-* properties"
    },
    {
        name: "columnRuleColor",
        description: "Specifies the color of the rule between columns"
    },
    {
        name: "columnRuleStyle",
        description: "Specifies the style of the rule between columns"
    },
    {
        name: "columnRuleWidth",
        description: "Specifies the width of the rule between columns"
    },
    {
        name: "columnSpan",
        description: "Specifies how many columns an element should span across"
    },
    {
        name: "columnWidth",
        description: "Specifies the column width"
    },
    {
        name: "columns",
        description: "A shorthand property for column-width and column-count"
    },
    {
        name: "contain",
        description: "Indicates that an element’s subtree is independent of the rest of the page"
    },
    {
        name: "containIntrinsicBlockSize",
        description: "Specifies the intrinsic block size of a container without considering its content"
    },
    {
        name: "containIntrinsicHeight",
        description: "Specifies the intrinsic height of a container without considering its content"
    },
    {
        name: "containIntrinsicInlineSize",
        description: "Specifies the intrinsic inline size of a container without considering its content"
    },
    {
        name: "containIntrinsicSize",
        description: "Provides a way to style an element as if it had a specific intrinsic size"
    },
    {
        name: "containIntrinsicWidth",
        description: "Specifies the intrinsic width of a container without considering its content"
    },
    {
        name: "container",
        description: "Enables an element to contain other elements in a specific formatting context"
    },
    {
        name: "containerName",
        description: "Names a container, allowing it to be referenced by its contents"
    },
    {
        name: "containerType",
        description: "Specifies the type of formatting context the container establishes"
    },
    {
        name: "content",
        description: "Used with the :before and :after pseudo-elements, to insert generated content"
    },
    {
        name: "counterIncrement",
        description: "Increases or decreases the value of one or more CSS counters"
    },
    {
        name: "counterReset",
        description: "Creates or resets one or more CSS counters"
    },
    {
        name: "counterSet",
        description: "Creates or sets one or more CSS counters"
    },
    {
        name: "cssFloat",
        description: "Specifies how an element should float"
    },
    {
        name: "cssText",
        description: "Defines the rendering of text, including whitespace, line breaks, and text transformations"
    },
    {
        name: "cursor",
        description: "Specifies the mouse cursor to be displayed when pointing over an element"
    },
    {
        name: "direction",
        description: "Specifies the text direction/writing direction"
    },
    {
        name: "display",
        description: "Specifies how a certain HTML element should be displayed"
    },
    {
        name: "dominantBaseline",
        description: "Sets the dominant baseline for text"
    },
    {
        name: "emptyCells",
        description: "Specifies whether or not to display borders and background on empty cells in a table"
    },
    {
        name: "fill",
        description: "Specifies the color or pattern used to fill a shape or text"
    },
    {
        name: "fillOpacity",
        description: "Defines the opacity of the color or pattern used for a fill"
    },
    {
        name: "fillRule",
        description: "Determines the algorithm used to determine what side of a path is inside"
    },
    {
        name: "filter",
        description: "Defines effects (e.g. blurring or color shifting) on an element before the element is displayed"
    },
    {
        name: "flex",
        description: "A shorthand property for the flex-grow, flex-shrink, and the flex-basis properties"
    },
    {
        name: "flexBasis",
        description: "Specifies the initial length of a flexible item"
    },
    {
        name: "flexDirection",
        description: "Specifies the direction of the flexible items"
    },
    {
        name: "flexFlow",
        description: "A shorthand property for the flex-direction and the flex-wrap properties"
    },
    {
        name: "flexGrow",
        description: "Specifies how much the item will grow relative to the rest"
    },
    {
        name: "flexShrink",
        description: "Specifies how the item will shrink relative to the rest"
    },
    {
        name: "flexWrap",
        description: "Specifies whether the flexible items should wrap or not"
    },
    {
        name: "float",
        description: "Specifies whether an element should float to the left, right, or not at all"
    },
    {
        name: "floodColor",
        description: "Specifies the color of the flood effect for SVG filters"
    },
    {
        name: "floodOpacity",
        description: "Defines the opacity for the color of the flood effect"
    },
    {
        name: "font",
        description: "A shorthand property for the font-style, font-variant, font-weight, font-size/line-height, and the font-family properties"
    },
    {
        name: "fontFamily",
        description: "Specifies the font family for text"
    },
    {
        name: "fontFeatureSettings",
        description: "Allows control over advanced typographic features in OpenType fonts"
    },
    {
        name: "fontKerning",
        description: "Controls the usage of the kerning information (how letters are spaced)"
    },
    {
        name: "fontOpticalSizing",
        description: "Enables automatic adjustment of font size to make fonts more readable"
    },
    {
        name: "fontPalette",
        description: "Specifies the palette of colors used for text"
    },
    {
        name: "fontSize",
        description: "Specifies the font size of text"
    },
    {
        name: "fontSizeAdjust",
        description: "Preserves the readability of text when font fallback occurs"
    },
    {
        name: "fontStretch",
        description: "Selects a normal, condensed, or expanded face from a font family"
    },
    {
        name: "fontStyle",
        description: "Specifies the font style for text"
    },
    {
        name: "fontSynthesis",
        description: "Controls which missing typefaces (bold or italic) may be synthesized by the browser"
    },
    {
        name: "fontSynthesisSmallCaps",
        description: "Controls the synthesis of small caps"
    },
    {
        name: "fontSynthesisStyle",
        description: "Controls the synthesis of styles, typically italic or oblique"
    },
    {
        name: "fontSynthesisWeight",
        description: "Controls the synthesis of font weights"
    },
    {
        name: "fontVariant",
        description: "Specifies whether or not a text should be displayed in a small-caps font"
    },
    {
        name: "fontVariantAlternates",
        description: "Controls the usage of alternate glyphs associated to alternative names defined in @font-feature-values"
    },
    {
        name: "fontVariantCaps",
        description: "Controls the usage of alternate glyphs for capital letters"
    },
    {
        name: "fontVariantEastAsian",
        description: "Controls the usage of alternate glyphs for East Asian scripts (e.g Japanese and Chinese)"
    },
    {
        name: "fontVariantLigatures",
        description: "Controls which ligatures and contextual forms are used in textual content of the elements it applies to"
    },
    {
        name: "fontVariantNumeric",
        description: "Controls the usage of alternate glyphs for numbers, fractions, and ordinal markers"
    },
    {
        name: "fontVariantPosition",
        description: "Controls the usage of alternate glyphs of smaller size positioned as superscript or subscript regarding the baseline of the font"
    },
    {
        name: "fontVariationSettings",
        description: "Allows control over advanced typographic features in OpenType fonts"
    },
    {
        name: "fontWeight",
        description: "Specifies the weight of a font"
    },
    {
        name: "forcedColorAdjust",
        description: "Allows an element to opt out of the Forced Color Mode"
    },
    {
        name: "gap",
        description: "A shorthand property for the row-gap and the column-gap properties"
    },
    {
        name: "grid",
        description: "A shorthand property for the grid-template-rows, grid-template-columns, grid-template-areas, grid-auto-rows, grid-auto-columns, and the grid-auto-flow properties"
    },
    {
        name: "gridArea",
        description: "Either specifies a name for the grid item, or this property is a shorthand property for the grid-row-start, grid-column-start, grid-row-end, and grid-column-end properties"
    },
    {
        name: "gridAutoColumns",
        description: "Specifies a default column size"
    },
    {
        name: "gridAutoFlow",
        description: "Specifies how auto-placed items are inserted in the grid"
    },
    {
        name: "gridAutoRows",
        description: "Specifies a default row size"
    },
    {
        name: "gridColumn",
        description: "A shorthand property for the grid-column-start and the grid-column-end properties"
    },
    {
        name: "gridColumnEnd",
        description: "Specifies where to end the grid item"
    },
    {
        name: "gridColumnGap",
        description: "Specifies the size of the gap between columns"
    },
    {
        name: "gridColumnStart",
        description: "Specifies where to start the grid item"
    },
    {
        name: "gridGap",
        description: "A shorthand property for the grid-row-gap and grid-column-gap properties"
    },
    {
        name: "gridRow",
        description: "A shorthand property for the grid-row-start and the grid-row-end properties"
    },
    {
        name: "gridRowEnd",
        description: "Specifies where to end the grid item"
    },
    {
        name: "gridRowGap",
        description: "Specifies the size of the gap between rows"
    },
    {
        name: "gridRowStart",
        description: "Specifies where to start the grid item"
    },
    {
        name: "gridTemplate",
        description: "A shorthand property for the grid-template-rows, grid-template-columns and grid-areas properties"
    },
    {
        name: "gridTemplateAreas",
        description: "Specifies how to display columns and rows, using named grid items"
    },
    {
        name: "gridTemplateColumns",
        description: "Specifies the size of the columns, and how many columns in a grid layout"
    },
    {
        name: "gridTemplateRows",
        description: "Specifies the size of the rows in a grid layout"
    },
    {
        name: "height",
        description: "Sets the height of an element"
    },
    {
        name: "hyphenateCharacter",
        description: "Specifies the character to use for hyphenation"
    },
    {
        name: "hyphens",
        description: "Sets how to split words to improve the layout of text"
    },
    {
        name: "imageOrientation",
        description: "Specifies how to correct the orientation of an image"
    },
    {
        name: "imageRendering",
        description: "Specifies the type of algorithm to use for image scaling"
    },
    {
        name: "inlineSize",
        description: "Specifies the size of an element in the inline direction"
    },
    {
        name: "inset",
        description: "Specifies the distance between an element and the parent element"
    },
    {
        name: "insetBlock",
        description: "Specifies the distance between an element and the parent element in the block direction"
    },
    {
        name: "insetBlockEnd",
        description: "Specifies the distance between the end of an element and the parent element in the block direction"
    },
    {
        name: "insetBlockStart",
        description: "Specifies the distance between the start of an element and the parent element in the block direction"
    },
    {
        name: "insetInline",
        description: "Specifies the distance between an element and the parent element in the inline direction"
    },
    {
        name: "insetInlineEnd",
        description: "Specifies the distance between the end of an element and the parent element in the inline direction"
    },
    {
        name: "insetInlineStart",
        description: "Specifies the distance between the start of an element and the parent element in the inline direction"
    },
    {
        name: "isolation",
        description: "Defines whether an element must create a new stacking content"
    },
    {
        name: "justifyContent",
        description: "Specifies the alignment between the items inside a flexible container when the items do not use all available space"
    },
    {
        name: "justifyItems",
        description: "Is set on the grid container. Specifies the alignment of grid items in the inline direction"
    },
    {
        name: "justifySelf",
        description: "Is set on the grid item. Specifies the alignment of the grid item in the inline direction"
    },
    {
        name: "left",
        description: "Specifies the left position of a positioned element"
    },
    {
        name: "letterSpacing",
        description: "Increases or decreases the space between characters in a text"
    },
    {
        name: "lightingColor",
        description: "Defines the color of the light source for filters"
    },
    {
        name: "lineBreak",
        description: "Specifies how/if to break lines"
    },
    {
        name: "lineHeight",
        description: "Sets the line height"
    },
    {
        name: "listStyle",
        description: "Sets all the properties for a list in one declaration"
    },
    {
        name: "listStyleImage",
        description: "Specifies an image as the list-item marker"
    },
    {
        name: "listStylePosition",
        description: "Specifies the position of the list-item markers (bullet points)"
    },
    {
        name: "listStyleType",
        description: "Specifies the type of list-item marker"
    },
    {
        name: "margin",
        description: "Sets all the margin properties in one declaration"
    },
    {
        name: "marginBlock",
        description: "Specifies the margin in the block direction"
    },
    {
        name: "marginBlockEnd",
        description: "Specifies the margin at the end in the block direction"
    },
    {
        name: "marginBlockStart",
        description: "Specifies the margin at the start in the block direction"
    },
    {
        name: "marginBottom",
        description: "Sets the bottom margin of an element"
    },
    {
        name: "marginInline",
        description: "Specifies the margin in the inline direction"
    },
    {
        name: "marginInlineEnd",
        description: "Specifies the margin at the end in the inline direction"
    },
    {
        name: "marginInlineStart",
        description: "Specifies the margin at the start in the inline direction"
    },
    {
        name: "marginLeft",
        description: "Sets the left margin of an element"
    },
    {
        name: "marginRight",
        description: "Sets the right margin of an element"
    },
    {
        name: "marginTop",
        description: "Sets the top margin of an element"
    },
    {
        name: "marker",
        description: "Specifies the marker(s) that will be used for a list item or line markers in SVG"
    },
    {
        name: "markerEnd",
        description: "Defines the arrowhead or polymarker that will be drawn at the final vertex of the given path or shape"
    },
    {
        name: "markerMid",
        description: "Defines the arrowhead or polymarker that will be drawn at all interior vertices of the given path or shape"
    },
    {
        name: "markerStart",
        description: "Defines the arrowhead or polymarker that will be drawn at the first vertex of the given path or shape"
    },
    {
        name: "mask",
        description: "Hides parts of an element by masking or clipping an image at specific places"
    },
    {
        name: "maskClip",
        description: "Specifies the mask area"
    },
    {
        name: "maskComposite",
        description: "Represents a compositing operation used on the current mask layer with the mask layers below it"
    },
    {
        name: "maskImage",
        description: "Specifies an image to be used as a mask layer for an element"
    },
    {
        name: "maskMode",
        description: "Specifies whether the mask layer image is treated as a luminance mask or as an alpha mask"
    },
    {
        name: "maskOrigin",
        description: "Specifies the origin position (the mask position area) of a mask layer image"
    },
    {
        name: "maskPosition",
        description: "Sets the starting position of a mask layer image (relative to the mask position area)"
    },
    {
        name: "maskRepeat",
        description: "Specifies how the mask layer image is repeated"
    },
    {
        name: "maskSize",
        description: "Specifies the size of a mask layer image"
    },
    {
        name: "maskType",
        description: "Specifies whether an SVG <mask> element is treated as a luminance mask or as an alpha mask"
    },
    {
        name: "mathStyle",
        description: "Specifies the style of mathematical expressions"
    },
    {
        name: "maxBlockSize",
        description: "Sets the maximum size of an element in the block direction"
    },
    {
        name: "maxHeight",
        description: "Sets the maximum height of an element"
    },
    {
        name: "maxInlineSize",
        description: "Sets the maximum size of an element in the inline direction"
    },
    {
        name: "maxWidth",
        description: "Sets the maximum width of an element"
    },
    {
        name: "minBlockSize",
        description: "Sets the minimum size of an element in the block direction"
    },
    {
        name: "minHeight",
        description: "Sets the minimum height of an element"
    },
    {
        name: "minInlineSize",
        description: "Sets the minimum size of an element in the inline direction"
    },
    {
        name: "minWidth",
        description: "Sets the minimum width of an element"
    },
    {
        name: "mixBlendMode",
        description: "Specifies how an element's content should blend with its direct parent background"
    },
    {
        name: "objectFit",
        description: "Specifies how the contents of a replaced element should be fitted to the box established by its used height and width"
    },
    {
        name: "objectPosition",
        description: "Specifies the alignment of the replaced element inside its box"
    },
    {
        name: "offset",
        description: "Is a shorthand, and specifies how to animate an element along a path"
    },
    {
        name: "offsetDistance",
        description: "Specifies the position along a path where an animated element is placed"
    },
    {
        name: "offsetPath",
        description: "Specifies the path an element is animated along"
    },
    {
        name: "offsetRotate",
        description: "Specifies rotation of an element as it is animated along a path"
    },
    {
        name: "opacity",
        description: "Sets the opacity level for an element"
    },
    {
        name: "order",
        description: "Sets the order of the flexible item, relative to the rest"
    },
    {
        name: "orphans",
        description: "Sets the minimum number of lines that must be left at the bottom of a page or column"
    },
    {
        name: "outline",
        description: "A shorthand property for the outline-width, outline-style, and the outline-color properties"
    },
    {
        name: "outlineColor",
        description: "Sets the color of an outline"
    },
    {
        name: "outlineOffset",
        description: "Offsets an outline, and draws it beyond the border edge"
    },
    {
        name: "outlineStyle",
        description: "Sets the style of an outline"
    },
    {
        name: "outlineWidth",
        description: "Sets the width of an outline"
    },
    {
        name: "overflow",
        description: "Specifies what happens if content overflows an element's box"
    },
    {
        name: "overflowAnchor",
        description: "Specifies whether or not content in viewable area in a scrollable contianer should be pushed down when new content is loaded above"
    },
    {
        name: "overflowClipMargin",
        description: "Extends the area into which content can overflow before it is clipped"
    },
    {
        name: "overflowWrap",
        description: "Specifies whether or not the browser can break lines with long words, if they overflow the container"
    },
    {
        name: "overflowX",
        description: "Specifies whether or not to clip the left/right edges of the content, if it overflows the element's content area"
    },
    {
        name: "overflowY",
        description: "Specifies whether or not to clip the top/bottom edges of the content, if it overflows the element's content area"
    },
    {
        name: "overscrollBehavior",
        description: "Specifies whether to have scroll chaining or overscroll affordance in x- and y-directions"
    },
    {
        name: "overscrollBehaviorBlock",
        description: "Specifies whether to have scroll chaining or overscroll affordance in the block direction"
    },
    {
        name: "overscrollBehaviorInline",
        description: "Specifies whether to have scroll chaining or overscroll affordance in the inline direction"
    },
    {
        name: "overscrollBehaviorX",
        description: "Specifies whether to have scroll chaining or overscroll affordance in x-direction"
    },
    {
        name: "overscrollBehaviorY",
        description: "Specifies whether to have scroll chaining or overscroll affordance in y-directions"
    },
    {
        name: "padding",
        description: "A shorthand property for all the padding-* properties"
    },
    {
        name: "paddingBlock",
        description: "Specifies the padding in the block direction"
    },
    {
        name: "paddingBlockEnd",
        description: "Specifies the padding at the end in the block direction"
    },
    {
        name: "paddingBlockStart",
        description: "Specifies the padding at the start in the block direction"
    },
    {
        name: "paddingBottom",
        description: "Sets the bottom padding of an element"
    },
    {
        name: "paddingInline",
        description: "Specifies the padding in the inline direction"
    },
    {
        name: "paddingInlineEnd",
        description: "Specifies the padding at the end in the inline direction"
    },
    {
        name: "paddingInlineStart",
        description: "Specifies the padding at the start in the inline direction"
    },
    {
        name: "paddingLeft",
        description: "Sets the left padding of an element"
    },
    {
        name: "paddingRight",
        description: "Sets the right padding of an element"
    },
    {
        name: "paddingTop",
        description: "Sets the top padding of an element"
    },
    {
        name: "page",
        description: "Specifies the named page(s) an element should be printed on"
    },
    {
        name: "pageBreakAfter",
        description: "Sets the page-break behavior after an element"
    },
    {
        name: "pageBreakBefore",
        description: "Sets the page-break behavior before an element"
    },
    {
        name: "pageBreakInside",
        description: "Sets the page-break behavior inside an element"
    },
    {
        name: "paintOrder",
        description: "Sets the order of how an SVG element or text is painted."
    },
    {
        name: "perspective",
        description: "Gives a 3D-positioned element some perspective"
    },
    {
        name: "perspectiveOrigin",
        description: "Defines at which position the user is looking at the 3D-positioned element"
    },
    {
        name: "placeContent",
        description: "Specifies align-content and justify-content property values for flexbox and grid layouts"
    },
    {
        name: "placeItems",
        description: "Specifies align-items and justify-items property values for grid layouts"
    },
    {
        name: "placeSelf",
        description: "Specifies align-self and justify-self property values for grid layouts"
    },
    {
        name: "pointerEvents",
        description: "Defines whether or not an element reacts to pointer events"
    },
    {
        name: "position",
        description: "Specifies the type of positioning method used for an element (static, relative, absolute or fixed)"
    },
    {
        name: "printColorAdjust",
        description: "Allows control over color adjustment when printing"
    },
    {
        name: "quotes",
        description: "Sets the type of quotation marks for embedded quotations"
    },
    {
        name: "resize",
        description: "Defines if (and how) an element is resizable by the user"
    },
    {
        name: "right",
        description: "Specifies the right position of a positioned element"
    },
    {
        name: "rotate",
        description: "Specifies the rotation of an element"
    },
    {
        name: "rowGap",
        description: "Specifies the gap between the grid rows"
    },
    {
        name: "rubyPosition",
        description: "Specifies the position of a ruby text relative to its base"
    },
    {
        name: "scale",
        description: "Specifies the size of an element by scaling up or down"
    },
    {
        name: "scrollBehavior",
        description: "Specifies whether to smoothly animate the scroll position in a scrollable box, instead of a straight jump"
    },
    {
        name: "scrollMargin",
        description: "Specifies the margin between the snap position and the container"
    },
    {
        name: "scrollMarginBlock",
        description: "Specifies the margin between the snap position and the container in the block direction"
    },
    {
        name: "scrollMarginBlockEnd",
        description: "Specifies the end margin between the snap position and the container in the block direction"
    },
    {
        name: "scrollMarginBlockStart",
        description: "Specifies the start margin between the snap position and the container in the block direction"
    },
    {
        name: "scrollMarginBottom",
        description: "Specifies the margin between the snap position on the bottom side and the container"
    },
    {
        name: "scrollMarginInline",
        description: "Specifies the margin between the snap position and the container in the inline direction"
    },
    {
        name: "scrollMarginInlineEnd",
        description: "Specifies the end margin between the snap position and the container in the inline direction"
    },
    {
        name: "scrollMarginInlineStart",
        description: "Specifies the start margin between the snap position and the container in the inline direction"
    },
    {
        name: "scrollMarginLeft",
        description: "Specifies the margin between the snap position on the left side and the container"
    },
    {
        name: "scrollMarginRight",
        description: "Specifies the margin between the snap position on the right side and the container"
    },
    {
        name: "scrollMarginTop",
        description: "Specifies the margin between the snap position on the top side and the container"
    },
    {
        name: "scrollPadding",
        description: "Specifies the distance from the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingBlock",
        description: "Specifies the distance in block direction from the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingBlockEnd",
        description: "Specifies the distance in block direction from the end of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingBlockStart",
        description: "Specifies the distance in block direction from the start of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingBottom",
        description: "Specifies the distance from the bottom of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingInline",
        description: "Specifies the distance in inline direction from the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingInlineEnd",
        description: "Specifies the distance in inline direction from the end of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingInlineStart",
        description: "Specifies the distance in inline direction from the start of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingLeft",
        description: "Specifies the distance from the left side of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingRight",
        description: "Specifies the distance from the right side of the container to the snap position on the child elements"
    },
    {
        name: "scrollPaddingTop",
        description: "Specifies the distance from the top of the container to the snap position on the child elements"
    },
    {
        name: "scrollSnapAlign",
        description: "Specifies where to position elements when the user stops scrolling"
    },
    {
        name: "scrollSnapStop",
        description: "Specifies scroll behaviour after fast swipe on trackpad or touch screen"
    },
    {
        name: "scrollSnapType",
        description: "Specifies how snap behaviour should be when scrolling"
    },
    {
        name: "scrollbarGutter",
        description: "Controls the presence of gutters for scrollbars"
    },
    {
        name: "shapeImageThreshold",
        description: "Defines a threshold for the alpha channel values to shape an element’s float area"
    },
    {
        name: "shapeMargin",
        description: "Specifies a margin for a shape-outside"
    },
    {
        name: "shapeOutside",
        description: "Specifies a shape around which content will wrap"
    },
    {
        name: "shapeRendering",
        description: "Provides hints to the renderer about what trade-offs to make when rendering shapes"
    },
    {
        name: "stopColor",
        description: "Specifies the color of the stop in a gradient"
    },
    {
        name: "stopOpacity",
        description: "Defines the opacity of a stop color in a gradient"
    },
    {
        name: "stroke",
        description: "Specifies the color or pattern used for the stroke of a shape or text"
    },
    {
        name: "strokeDasharray",
        description: "Specifies the pattern of dashes and gaps used to stroke paths"
    },
    {
        name: "strokeDashoffset",
        description: "Specifies the distance along the path where the dash pattern will start"
    },
    {
        name: "strokeLinecap",
        description: "Defines the shape used at the end of open subpaths when stroking"
    },
    {
        name: "strokeLinejoin",
        description: "Specifies the shape to be used at the corners of paths or basic shapes when they are stroked"
    },
    {
        name: "strokeMiterlimit",
        description: "Limits the ratio of the miter length to the stroke-width in the miter join"
    },
    {
        name: "strokeOpacity",
        description: "Defines the opacity of the stroke color"
    },
    {
        name: "strokeWidth",
        description: "Specifies the width of the stroke on the current object"
    },
    {
        name: "tabSize",
        description: "Specifies the width of a tab character"
    },
    {
        name: "tableLayout",
        description: "Defines the algorithm used to lay out table cells, rows, and columns"
    },
    {
        name: "textAlign",
        description: "Specifies the horizontal alignment of text"
    },
    {
        name: "textAlignLast",
        description: "Describes how the last line of a block or a line right before a forced line break is aligned when text-align is 'justify'"
    },
    {
        name: "textAnchor",
        description: "Specifies how text is horizontally aligned relative to a given point"
    },
    {
        name: "textCombineUpright",
        description: "Specifies the combination of multiple characters into the space of a single character"
    },
    {
        name: "textDecoration",
        description: "Specifies the decoration added to text"
    },
    {
        name: "textDecorationColor",
        description: "Specifies the color of the text-decoration"
    },
    {
        name: "textDecorationLine",
        description: "Specifies the type of line in a text-decoration"
    },
    {
        name: "textDecorationSkipInk",
        description: "Specifies whether the text decoration should skip over descenders and ascenders"
    },
    {
        name: "textDecorationStyle",
        description: "Specifies the style of the line in a text decoration"
    },
    {
        name: "textDecorationThickness",
        description: "Specifies the thickness of the decoration line"
    },
    {
        name: "textEmphasis",
        description: "A shorthand property for the text-emphasis-style and text-emphasis-color properties"
    },
    {
        name: "textEmphasisColor",
        description: "Specifies the color of emphasis marks"
    },
    {
        name: "textEmphasisPosition",
        description: "Specifies the position of emphasis marks"
    },
    {
        name: "textEmphasisStyle",
        description: "Specifies the style of emphasis marks"
    },
    {
        name: "textIndent",
        description: "Specifies the indentation of the first line in a text-block"
    },
    {
        name: "textOrientation",
        description: "Defines the orientation of characters in a line"
    },
    {
        name: "textOverflow",
        description: "Specifies what should happen when text overflows the containing element"
    },
    {
        name: "textRendering",
        description: "Provides hints to the rendering engine about what to optimize for when rendering text"
    },
    {
        name: "textShadow",
        description: "Adds shadow to text"
    },
    {
        name: "textTransform",
        description: "Controls the capitalization of text"
    },
    {
        name: "textUnderlineOffset",
        description: "Specifies the offset distance of the underline text decoration"
    },
    {
        name: "textUnderlinePosition",
        description: "Specifies the position of the underline text decoration"
    },
    {
        name: "top",
        description: "Specifies the top position of a positioned element"
    },
    {
        name: "touchAction",
        description: "Specifies how the user interface should handle touch inputs"
    },
    {
        name: "transform",
        description: "Applies a 2D or 3D transformation to an element"
    },
    {
        name: "transformBox",
        description: "Defines the layout box to which the transform and transform-origin properties relate"
    },
    {
        name: "transformOrigin",
        description: "Allows you to change the position on transformed elements"
    },
    {
        name: "transformStyle",
        description: "Specifies how nested elements are rendered in 3D space"
    },
    {
        name: "transition",
        description: "A shorthand property for all the transition-* properties"
    },
    {
        name: "transitionDelay",
        description: "Specifies when the transition effect will start"
    },
    {
        name: "transitionDuration",
        description: "Specifies how many seconds or milliseconds a transition effect takes to complete"
    },
    {
        name: "transitionProperty",
        description: "Specifies the name of the CSS property the transition effect is for"
    },
    {
        name: "transitionTimingFunction",
        description: "Specifies the speed curve of the transition effect"
    },
    {
        name: "translate",
        description: "Specifies the position of an element"
    },
    {
        name: "unicodeBidi",
        description: "Used together with the direction property to set or return whether the text should be overridden to support multiple languages in the same document"
    },
    {
        name: "userSelect",
        description: "Specifies whether the text of an element can be selected"
    },
    {
        name: "verticalAlign",
        description: "Sets the vertical alignment of an element"
    },
    {
        name: "visibility",
        description: "Specifies whether or not an element is visible"
    },
    {
        name: "WebkitBackdropFilter",
        description: "Defines the effect(s) to be applied to the area behind an element"
    },
    {
        name: "WebkitOverflowScrolling",
        description: "Controls whether or not touch devices use momentum-based scrolling for a given element"
    },
    {
        name: "whiteSpace",
        description: "Specifies how white-space inside an element is handled"
    },
    {
        name: "widows",
        description: "Sets the minimum number of lines that must be left at the top of a page or column"
    },
    {
        name: "width",
        description: "Sets the width of an element"
    },
    {
        name: "willChange",
        description: "Provides a hint to browsers about the kind of changes to expect on an element, to optimize performance"
    },
    {
        name: "wordBreak",
        description: "Specifies how words should break when reaching the end of a line"
    },
    {
        name: "wordSpacing",
        description: "Increases or decreases the space between words in a text"
    },
    {
        name: "wordWrap",
        description: "Allows long, unbreakable words to be broken and wrap to the next line"
    },
    {
        name: "writingMode",
        description: "Specifies whether lines of text are laid out horizontally or vertically"
    },
    {
        name: "zIndex",
        description: "Sets the stack order of a positioned element"
    }
];
